module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "front-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('b', [_vm._v("Illustrations")])]), _vm._v(" "), _c('div', {
    staticClass: "hang"
  }, [_c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_01"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking into Garbh Choire Mòr.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The interior of Ruigh-aiteachain bothy.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The two engines of the Oxford Mk I on a spur of Beinn a’ Bhuird.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shelter Stone Crag and Cairn Etchachan.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shelter Stone.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The path between Ben Macdui and Loch Etchachan.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking down on the El Alamein Refuge and the slopes of Strath Nethy.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The inscription on the El Alamein Refuge, bearing the insignia of the Highland Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The ruins of Slugain Lodge in Upper Gleann an t-Slugain, the Fairy Glen.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A small stone tablet, once part of the St Valery refuge and inscribed with its name.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sappers’ Bothy near the summit of Ben Macdui.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The surreal granite tors on the vast expanse of the Ben Avon plateau.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking south into the wide breach of the Lairig Ghru from Braeriach.")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindenta",
    attrs: {
      "id": "rplat_14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_plate_section#plat_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lairig Ghru, looking north, with the Devil’s Peak in the centre.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2757509c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_illustrations.vue
// module id = 72
// module chunks = 0